import { BuilderProjectModel, Project } from "../../models/project";
import { useContext, useEffect, useState } from "react";
import { getProject, getProjectCards } from "../../api/ProjectLoader";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import BidChart from "../bid/BidChart";
import { useAuthInfo } from "@propelauth/react";
import BuilderBidChartInfo, {
    DeveloperBidChartInfo,
} from "../bid/BidChartInfo";
import { Link } from "react-router-dom";

import { Notification } from "../../models/notification_model";
import { getNotifications } from "../../api/notification_api";
import { NotificationPWidget } from "../notification/notificationWidget";
import { UserContext } from "../../contexts/UserContext";
import { CompanyType } from "../../models/company";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";

interface ListProjectsProps {
    projects: Project[];
    notifications: Notification[];
}

type ProjectCardProps = {
    project: Project;
    notifications: Notification[];
};

function ProjectCard({ project, notifications }: ProjectCardProps) {
    const { accessToken } = useAuthInfo();
    const userContext = useContext(UserContext);
    const [projectNotifications, setProjectNotifications] = useState<Notification[]>([]);
    const [projectSummary, setProjectSummary] = useState<BuilderProjectModel | null>(null);

    useEffect(() => {
        if (project && notifications) {
            const not = notifications
                .filter((item) =>
                    item.notification.some(
                        (notf) => notf.project_id === (project as any)._id
                    )
                )
                .map((item) => ({
                    ...item,
                    notification: item.notification.sort(
                        (a, b) =>
                            new Date(b.created_at).getTime() -
                            new Date(a.created_at).getTime()
                    ),
                }))
                .slice(0, 5);
            setProjectNotifications(not);

            getProject(project.project_id, accessToken as string).then(
                (data) => {
                    setProjectSummary(data);
                }
            );
        }
    }, []);

    return (
        <div className="">
            <div className="">
                <Card className=" shadow-lg border border-gray-200 rounded-lg bg-gray-50">
                    <CardHeader>
                        <CardTitle className="text-center">
                            <Link to={`/project/${project.project_id}`}>
                                Project: {project.number} - {project.name}
                            </Link>{" "}
                        </CardTitle>
                    </CardHeader>
                    {/*{userContext?.company_type === CompanyType.developer ? (*/}
                    {/*User is the Developer*/}
                    {userContext?.company_id === project.company_id ? (
                        <CardContent className="flex flex-col lg:flex-row  items-center gap-y-5 gap-x-5 columns-2 justify-between">
                            <div className="w-full lg:w-1/2 xl:w-[40%]">
                                <BidChart
                                    project_id={project.project_id}
                                    height="h-[300px]"
                                    isOnHomePage={true}
                                />
                            </div>
                            <div className="w-full  flex 1250px:w-1/2 xl:w-[60%] mt-5 xl:mt-0 flex-col xl:flex-row">
                                <div className="w-full">
                                    {projectSummary && (
                                        <DeveloperBidChartInfo
                                            accessToken={accessToken}
                                            projectSummary={projectSummary}
                                        />
                                    )}
                                </div>
                                <div className="w-full mt-5 xl:mt-0">
                                    <NotificationPWidget
                                        notifications={projectNotifications}
                                    />
                                </div>
                            </div>
                        </CardContent>
                    ) : (
                        <CardContent className="flex  items-center gap-y-5 columns-2 justify-between">
                            {/*User is the Bidder*/}

                            <div className="w-full ">
                                {projectSummary && (
                                    <BuilderBidChartInfo
                                        accessToken={accessToken}
                                        projectSummary={projectSummary}
                                    />
                                )}
                            </div>
                            <div className="w-full ">
                                <NotificationPWidget
                                    notifications={projectNotifications}
                                />
                            </div>
                        </CardContent>
                    )}
                </Card>
            </div>
        </div>
    );
}

function ListProjects({ projects, notifications }: ListProjectsProps) {
    return (
        <div>
            <ul className="flex flex-col gap-y-5">
                {projects.map((project) => (
                    <ProjectCard
                        key={project.number}
                        project={project}
                        notifications={notifications}
                    />
                ))}
            </ul>
        </div>
    );
}

function ListOfProjectCards() {
    const { accessToken, isLoggedIn } = useAuthInfo();
    const [response, setResponse] = useState<any>(null);
    const [notifications, setNotifications] = useState<Notification[]>([]);

    useEffect(() => {
        getProjectCards(accessToken as string).then((data) =>
            setResponse(data)
        );
        const fetchNotifications = async () => {
            const data = await getNotifications(accessToken!);
            setNotifications(data);
        };

        fetchNotifications();
    }, [isLoggedIn]);

    if (response === null || notifications.length === 0) {
        return <div><BaseLoadingSpinner/></div>;
    }

    return <ListProjects projects={response} notifications={notifications} />;
}

export default ListOfProjectCards;
